import { createReducer } from '@reduxjs/toolkit';
import { initializeInventories } from './actions';

export const inventories = createReducer([], (builder) => {
  builder.addCase(initializeInventories, (state, action) => action.payload);
});
